import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-border bg-black" data-testid="footer">
    <div className="mx-auto max-w-[1600px] px-5 py-16 md:px-8">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <h3 className="font-display text-4xl font-extrabold tracking-tighter md:text-6xl">THE HOODIE<br />PROJECT®</h3>
          <p className="mt-4 max-w-sm text-sm text-muted-foreground">One hoodie. Infinite lives. Buy it, wear it, paint it, resell it — and put money back in your community.</p>
        </div>
        <div>
          <p className="mb-4 text-xs tracking-[0.2em] text-muted-foreground">EXPLORE</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-muted-foreground">Shop</Link></li>
            <li><Link to="/market" className="hover:text-muted-foreground">Resale Market</Link></li>
            <li><Link to="/events" className="hover:text-muted-foreground">Events</Link></li>
            <li><Link to="/gallery" className="hover:text-muted-foreground">Gallery</Link></li>
          </ul>
        </div>
        <div>
          <p className="mb-4 text-xs tracking-[0.2em] text-muted-foreground">SELL WITH US</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="hover:text-muted-foreground">Become a Seller</Link></li>
            <li><Link to="/find-us" className="hover:text-muted-foreground">Find Us In Stores</Link></li>
            <li><a href="/api/feed/google.xml" className="hover:text-muted-foreground">Product Feed</a></li>
          </ul>
        </div>
      </div>
      <div className="mt-12 flex flex-col justify-between gap-4 border-t border-border pt-6 text-xs text-muted-foreground md:flex-row">
        <p>© 2026 The Hoodie Project. All rights reserved.</p>
        <p>Made for the culture.</p>
      </div>
    </div>
  </footer>
);
